import { createRouter, createWebHistory } from "vue-router";
import store from "@/store"; // Importe le store Vuex
import HTTP from "@/axios";

// Pages
import Dashboard from "@/pages/Dashboard.vue";
import Employees from "@/pages/Employees/index.vue";
import CreateEmployees from "@/pages/Employees/Create.vue";
import ListEmployees from "@/pages/Employees/List.vue";
import EmployeProfile from "@/pages/Employees/Profile.vue";

import Agencies from "@/pages/Agencies/index.vue";
import ListAgencies from "@/pages/Agencies/List.vue";
import CreateAgency from "@/pages/Agencies/Create.vue";

import Trainings from "@/pages/Trainings/index.vue";
import ListTrainings from "@/pages/Trainings/List.vue";
import TraineeTimeline from "@/pages/Trainings/Timeline.vue";
import CreateTrainings from "@/pages/Trainings/Create.vue";
import CreateTrainingsIndividual from "@/pages/Trainings/Create_Individual.vue";
import PermisT from "@/pages/Trainings/PermisT.vue";
import ExpiringTrainings from "@/pages/Trainings/Expiring.vue";
import PaymentTraining from "@/pages/Trainings/Payment.vue";
import TrainingSuccess from "@/pages/Trainings/Success.vue";

import Register from "@/pages/Register.vue";
import LandingStrasbourg from "@/pages/LandingStrasbourg.vue";
import Login from "@/pages/Login.vue";
import ForgotPassword from "@/pages/ForgotPassword.vue";
import Settings from "@/pages/Settings.vue";

import SetupCompany from "@/pages/SetupCompany.vue";
import CompanySettings from "@/pages/CompanySettings.vue";
import Invoices from "@/pages/Invoices.vue";
import Certificates from "@/pages/Certificates.vue";
import Conventions from "@/pages/Conventions.vue";
import Opco from "@/pages/Opco.vue";
import Transactions from "@/pages/Transactions.vue";
import PurchaseCredits from "@/pages/PurchaseCredits.vue";
import Moderations from "@/pages/Moderations.vue";

import Catalog from "@/pages/Trainings/Catalog.vue";

import MicroLearning from "@/pages/MicroLearning/index.vue";
import MicroLearningModulesList from "@/pages/MicroLearning/ModulesList.vue";
import MicroLearningModuleForm from "@/pages/MicroLearning/ModuleForm.vue";
import MicroLearningAssignmentsList from "@/pages/MicroLearning/AssignmentsList.vue";
import MicroLearningAssignmentDetail from "@/pages/MicroLearning/AssignmentDetail.vue";
import VirtualClassrooms from "@/pages/VirtualClassrooms/index.vue";
import VirtualClassroomsList from "@/pages/VirtualClassrooms/List.vue";
import VirtualClassroomForm from "@/pages/VirtualClassrooms/Form.vue";
import VirtualClassroomDetail from "@/pages/VirtualClassrooms/Detail.vue";

import BackgroundCheckCandidateForm from "@/pages/BackgroundCheck/CandidateForm.vue";
import BackgroundCheckList from "@/pages/BackgroundCheck/List.vue";
import BackgroundCheckDetail from "@/pages/BackgroundCheck/Detail.vue";
import BackgroundCheckDone from "@/pages/BackgroundCheck/Done.vue";

const routes = [
  {
    path: "/",
    component: Dashboard,
    name: "dashboard",
    meta: { requiresAuth: true }
  },
  {
    path: "/register",
    component: Register,
    name: "register",
  },
  {
    path: "/landing-strasbourg",
    component: LandingStrasbourg,
    name: "landing-strasbourg",
  },
  {
    path: "/login",
    component: Login,
    name: "login",
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter(to, from, next) {
      localStorage.clear();
      store.dispatch("logout");
      next({ name: "login" });
    },
  },
  {
    path: "/catalog",
    component: Catalog,
    name: "catalog",
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    name: "forgot-password",
  },
  {
    path: "/setup-company",
    component: SetupCompany,
    name: "setup-company",
    meta: { requiresAuth: true }
  },
  {
    path: "/opco",
    component: Opco,
    name: "opco",
    meta: { requiresAuth: true }
  },
  {
    path: "/settings",
    component: Settings,
    name: "settings",
    meta: { requiresAuth: true }
  },
  {
    path: "/company-settings",
    component: CompanySettings,
    name: "company-settings",
    meta: { requiresAuth: true, requiresManager: true }
  },
  {
    path: "/invoices",
    component: Invoices,
    name: "invoices",
    meta: { requiresAuth: true }
  },
  {
    path: "/conventions",
    component: Conventions,
    name: "conventions",
    meta: { requiresAuth: true }
  },
  {
    path: "/certificates",
    component: Certificates,
    name: "certificates",
    meta: { requiresAuth: true }
  },
  {
    path: "/moderations",
    component: Moderations,
    name: "moderations",
    meta: { requiresAuth: true }
  },
  {
    path: "/transactions",
    component: Transactions,
    name: "transactions",
    meta: { requiresAuth: true }
  },
  {
    path: "/purchase-credits",
    component: PurchaseCredits,
    name: "purchase-credits",
    meta: { requiresAuth: true }
  },
  {
    path: "/employees",
    component: Employees,
    name: "employees",
    meta: { requiresAuth: true },
    children: [
      {
        path: "create", // Pas besoin du slash ici, car c'est une route enfant
        component: CreateEmployees,
        name: "create-employee",
        meta: { requiresAuth: true },
      },
      {
        path: "list", // Pas besoin du slash ici, car c'est une route enfant
        component: ListEmployees,
        name: "list-employee",
        meta: { requiresAuth: true },
      },
      {
        path: "profile/:employeeId", // Pas besoin du slash ici, car c'est une route enfant
        component: EmployeProfile,
        name: "profile-employee",
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/agencies",
    component: Agencies,
    name: "agencies",
    meta: { requiresAuth: true, requiresAgencies: true },
    children: [
      {
        path: "list",
        component: ListAgencies,
        name: "list-agencies",
        meta: { requiresAuth: true, requiresAgencies: true },
      },
      {
        path: "create",
        component: CreateAgency,
        name: "create-agency",
        meta: { requiresAuth: true, requiresAgencies: true },
      },
      {
        path: "edit/:id",
        component: CreateAgency,
        name: "edit-agency",
        meta: { requiresAuth: true, requiresAgencies: true },
      },
    ],
  },
  {
    path: "/trainings",
    component: Trainings,
    name: "trainings",
    meta: { requiresAuth: true },
    children: [
      {
        path: "create", // Pas besoin du slash ici, car c'est une route enfant
        component: CreateTrainings,
        name: "create-trainings",
        meta: { requiresAuth: true },
      },
      {
        path: "permis-t", // Pas besoin du slash ici, car c'est une route enfant
        component: PermisT,
        name: "permis-t",
        meta: { requiresAuth: true },
      },
      {
        path: "list", // Pas besoin du slash ici, car c'est une route enfant
        component: ListTrainings,
        name: "list-trainings",
        meta: { requiresAuth: true },
      },
      {
        path: "timeline-trainee/:traineeId", // Pas besoin du slash ici, car c'est une route enfant
        component: TraineeTimeline,
        name: "timeline-trainee",
        meta: { requiresAuth: true },
      },
      {
        path: "payment", // Pas besoin du slash ici, car c'est une route enfant
        component: PaymentTraining,
        name: "payment",
        meta: { requiresAuth: true },
      },
       {
        path: "success", // Pas besoin du slash ici, car c'est une route enfant
        component: TrainingSuccess,
        name: "success",
        meta: { requiresAuth: true },
      },
      {
        path: "create-individual",
        component: CreateTrainingsIndividual,
        name: "create-trainings-individual",
        meta: { requiresAuth: true },
      },
      {
        path: "inactivity",
        component: () => import("@/pages/Trainings/Inactivity.vue"),
        name: "trainings-inactivity",
        meta: { requiresAuth: true, requiresManager: true },
      },
      {
        path: "expiring",
        component: ExpiringTrainings,
        name: "trainings-expiring",
        meta: { requiresAuth: true },
      },
    ],
  },
  // ─── Micro-Learning ─────────────────────────────────────────────
  {
    path: "/micro-learning",
    component: MicroLearning,
    name: "micro-learning",
    meta: { requiresAuth: true },
    children: [
      {
        path: "modules",
        component: MicroLearningModulesList,
        name: "micro-learning-modules",
        meta: { requiresAuth: true },
      },
      {
        path: "modules/new",
        component: MicroLearningModuleForm,
        name: "micro-learning-module-create",
        meta: { requiresAuth: true },
      },
      {
        path: "modules/edit/:id",
        component: MicroLearningModuleForm,
        name: "micro-learning-module-edit",
        meta: { requiresAuth: true },
      },
      {
        path: "assignments",
        component: MicroLearningAssignmentsList,
        name: "micro-learning-assignments",
        meta: { requiresAuth: true },
      },
      {
        path: "assignments/:id",
        component: MicroLearningAssignmentDetail,
        name: "micro-learning-assignment-detail",
        meta: { requiresAuth: true },
      },
    ],
  },
  // ─── Virtual Classrooms ─────────────────────────────────────────
  {
    path: "/virtual-classrooms",
    component: VirtualClassrooms,
    name: "virtual-classrooms",
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: VirtualClassroomsList,
        name: "virtual-classrooms-list",
        meta: { requiresAuth: true },
      },
      {
        path: "new",
        component: VirtualClassroomForm,
        name: "virtual-classroom-create",
        meta: { requiresAuth: true },
      },
      {
        path: "edit/:id",
        component: VirtualClassroomForm,
        name: "virtual-classroom-edit",
        meta: { requiresAuth: true },
      },
      {
        path: "detail/:id",
        component: VirtualClassroomDetail,
        name: "virtual-classroom-detail",
        meta: { requiresAuth: true },
      },
    ],
  },
  // ─── Background Check — Manager (auth required) ───────────────
  {
    path: "/background-check/list",
    component: BackgroundCheckList,
    name: "background-check-list",
    meta: { requiresAuth: true },
  },
  {
    path: "/background-check/detail/:id",
    component: BackgroundCheckDetail,
    name: "background-check-detail",
    meta: { requiresAuth: true },
  },
  // ─── Background Check — Public candidat (no auth) ────────────
  {
    path: "/verification/done",
    component: BackgroundCheckDone,
    name: "verification-done",
  },
  {
    path: "/verification/resume/:token",
    component: BackgroundCheckCandidateForm,
    name: "verification-resume",
  },
  {
    path: "/verification/:companyToken",
    component: BackgroundCheckCandidateForm,
    name: "verification-candidate",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn; // Vérifie l'état dans le store Vuex

  if (
    typeof window !== "undefined" &&
    window.location.hostname === "strasbourg.pika-aero.com" &&
    to.path === "/" &&
    !isLoggedIn
  ) {
    return next({ name: "landing-strasbourg" });
  }

  // Vérifie si la route nécessite d'être connecté
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      // Redirige vers la page de login si non connecté, en gardant la page demandée
      const query = to.fullPath !== "/" ? { redirect: to.fullPath } : {};
      return next({ name: "login", query });
    }
  }

  const needsManager = to.matched.some((record) => record.meta.requiresManager);
  const needsAgencies = to.matched.some((record) => record.meta.requiresAgencies);

  if (needsManager || needsAgencies) {
    let profile;
    try {
      const response = await HTTP.get("/user/profile");
      profile = response.data;
    } catch (err) {
      console.error("[router] Unable to fetch profile:", err);
      return next({ name: "dashboard" });
    }

    if (profile.profile?.role !== "manager")
      return next({ name: "dashboard" });

    if (needsAgencies) {
      let displayAgencies = false;
      try {
        const companyResponse = await HTTP.get("/company");
        displayAgencies = !!companyResponse.data.company?.metadata?.displayAgencies;
      } catch (err) {
        console.error("[router] Unable to fetch company:", err);
      }

      if (!displayAgencies)
        return next({ name: "dashboard" });
    }
  }

  // Si tout est OK, passe à la page suivante
  next();
});

export default router;
